<template>
    <div>
        <div class="cms-content-our-range-filter__filter">
            <button
                v-on:click.prevent="toggleDropdown"
                class="cms-content-our-range-filter__button electric-green cms-content-our-range-filter__button--hidden-xs btn"
                :class="{ 'cms-content-our-range-filter__button--active': isActive }"
            >
                <slot name="title" />
            </button>
            <span class="cms-content-our-range__heading"><slot name="title" /></span>
            <div
                class="cms-content-our-range-filter__dropdown rd-card cms-content-our-range-filter__input"
                :class="{
                    'cms-content-our-range-filter__dropdown--active': isActive,
                    'cms-content-our-range-filter__dropdown--wide': wide,
                }"
            >
                <slot />
            </div>
        </div>
        <div
            v-on:click="isActive = false"
            class="cms-content-our-range-filter__filter--overlay"
            v-show="isActive"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        wide: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
    methods: {
        toggleDropdown() {
            this.isActive = !this.isActive;
        },
        close() {
            if (!this.$el.contains(event.target)) {
                this.isActive = false;
            }
        },
        escClose() {
            if (event.keyCode === 27) {
                this.isActive = false;
            }
        },
    },
    mounted() {
        document.addEventListener("click", this.close);
        document.addEventListener("keyup", this.escClose);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.close);
        document.removeEventListener("keyup", this.escClose);
    },
};
</script>
